<div class="min-h-screen bg-bg-base text-text-primary">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 antialiased select-none">

    @if (isLoading) {
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-8 animate-pulse">

      <div class="lg:col-span-2 space-y-8">

        <div class="surface-card rounded-3xl p-6 md:p-8 space-y-4">
          <div class="h-8 bg-bg-secondary rounded-lg w-3/4 mb-2"></div>
          <div class="flex items-center gap-3">
            <div class="w-4 h-4 bg-bg-secondary rounded"></div>
            <div class="h-4 bg-bg-secondary rounded-md w-48"></div>
          </div>
          <div class="flex items-center gap-3">
            <div class="w-4 h-4 bg-bg-secondary rounded"></div>
            <div class="h-4 bg-bg-secondary rounded-md w-64"></div>
          </div>
          <div class="space-y-2.5 pt-3 border-t border-border-subtle">
            <div class="h-3.5 bg-bg-secondary rounded w-full"></div>
            <div class="h-3.5 bg-bg-secondary rounded w-5/6"></div>
            <div class="h-3.5 bg-bg-secondary rounded w-4/6"></div>
          </div>
        </div>

        <div class="surface-card rounded-3xl p-6 md:p-8 space-y-4">
          <div class="h-5 bg-bg-secondary rounded-md w-32 mb-2"></div>
          <div class="aspect-[16/10] bg-bg-secondary rounded-2xl border border-border-subtle"></div>
        </div>

        <div class="surface-card rounded-3xl p-6 md:p-8 space-y-5">
          <div class="h-5 bg-bg-secondary rounded-md w-40 mb-2"></div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            @for (item of [1,2,3,4]; track item) {
            <div class="p-4 bg-surface-elevated border border-border-subtle rounded-2xl space-y-3">
              <div class="h-4 bg-bg-secondary rounded w-3/4"></div>
              <div class="h-3.5 bg-bg-secondary rounded w-1/2"></div>
              <div class="h-4 bg-bg-secondary rounded w-2/3 pt-1"></div>
              <div class="h-3 bg-bg-secondary rounded w-1/3"></div>
            </div>
            }
          </div>
        </div>

        <div class="surface-card rounded-3xl p-6 md:p-8 space-y-5">
          <div class="h-5 bg-bg-secondary rounded-md w-36 mb-2"></div>
          <div class="grid grid-cols-2 md:grid-cols-3 gap-4">
            @for (item of [1,2,3,4,5,6]; track item) {
            <div class="flex items-center gap-3 p-3 bg-surface-elevated border border-border-subtle rounded-xl">
              <div class="w-5 h-5 bg-bg-secondary rounded-md shrink-0"></div>
              <div class="h-3.5 bg-bg-secondary rounded w-24"></div>
            </div>
            }
          </div>
        </div>

        <div class="surface-card rounded-3xl p-6 md:p-8 space-y-5">
          <div class="h-5 bg-bg-secondary rounded-md w-44 mb-2"></div>
          <div class="space-y-3.5">
            @for (item of [1,2,3]; track item) {
            <div class="flex items-center gap-3">
              <div class="w-2 h-2 bg-text-muted rounded-full shrink-0"></div>
              <div class="h-4 bg-bg-secondary rounded-md w-4/5"></div>
            </div>
            }
          </div>
        </div>

        <div class="surface-card rounded-3xl p-6 md:p-8 space-y-5">
          <div class="h-5 bg-bg-secondary rounded-md w-28 mb-2"></div>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            @for (item of [1,2,3]; track item) {
            <div class="aspect-[4/3] bg-bg-secondary rounded-2xl border border-border-subtle"></div>
            }
          </div>
        </div>

      </div>

      <div class="lg:col-span-1">
        <div class="sticky top-24 space-y-6">

          <div class="surface-card rounded-3xl p-6 space-y-4">
            <div class="h-5 bg-bg-secondary rounded-md w-32 mb-2"></div>
            <div class="space-y-3">
              @for (item of [1,2,3]; track item) {
              <div class="flex justify-between items-center pb-2 border-b border-border-subtle last:border-0 last:pb-0">
                <div class="h-3.5 bg-bg-secondary rounded w-24"></div>
                <div class="h-3.5 bg-bg-secondary rounded w-16"></div>
              </div>
              }
            </div>
          </div>

          <div class="surface-card rounded-3xl p-6 space-y-4">
            <div class="h-5 bg-bg-secondary rounded-md w-40 mb-2"></div>
            <div class="space-y-3">
              <div class="h-11 bg-surface-elevated border border-border-subtle rounded-xl"></div>
              <div class="h-11 bg-surface-elevated border border-border-subtle rounded-xl"></div>
              <div class="h-11 bg-surface-elevated border border-border-subtle rounded-xl"></div>
              <div class="h-24 bg-surface-elevated border border-border-subtle rounded-xl"></div>
              <div class="h-12 bg-bg-secondary rounded-xl w-full mt-2"></div>
            </div>
          </div>

          <div class="surface-card rounded-3xl p-6 space-y-3">
            <div class="h-11 bg-bg-secondary rounded-xl w-full"></div>
            <div class="h-11 bg-surface-elevated border border-border-subtle rounded-xl w-full"></div>
            <div class="h-11 bg-surface-elevated border border-border-subtle rounded-xl w-full"></div>
          </div>

        </div>
      </div>

    </div>
    } @else {

    <div class="grid grid-cols-1 lg:grid-cols-3 gap-8">

      <div class="lg:col-span-2 space-y-8">
        <app-project-header [projectName]="projectName" [developer]="developer" [location]="location"
          [description]="description">
        </app-project-header>

        @if (masterplanImage) {
        <app-masterplan [masterplanImage]="masterplanImage">
        </app-masterplan>
        }

        @if (unitTypes.length > 0) {
        <app-unit-types [unitTypes]="unitTypes">
        </app-unit-types>
        }

        @if (amenities.length > 0) {
        <app-amenities [amenities]="amenities">
        </app-amenities>
        }

        @if (paymentPlans.length > 0) {
        <app-project-payment-plans [paymentPlans]="paymentPlans">
        </app-project-payment-plans>
        }

        @if (galleryImages.length > 0) {
        <app-project-gallery [galleryImages]="galleryImages">
        </app-project-gallery>
        }
      </div>

      <div class="lg:col-span-1">
        <div class="sticky top-24 space-y-6">

          <!-- Quick Info + Pricing -->
          <div class="surface-card rounded-3xl p-5 md:p-6 antialiased">
            <div class="flex items-center gap-2 mb-5 pb-2 border-b border-border-subtle">
              <div class="w-1.5 h-3.5 bg-primary rounded-sm shadow-sm"></div>
              <h3 class="text-xs font-black text-text-primary uppercase tracking-wider font-mono">
                {{ 'projectsDetails.quickMetrics' | translate }}
              </h3>
            </div>

            <div class="space-y-4">
              @if (deliveryDate) {
              <div class="flex items-center justify-between pb-3.5 border-b border-border-subtle">
                <div class="flex items-center gap-2.5 text-text-secondary">
                  <div class="w-6 h-6 rounded-lg bg-surface-elevated border border-border flex items-center justify-center text-text-muted">
                    <i class="fa-regular fa-calendar-check text-[10px]"></i>
                  </div>
                  <span class="text-xs font-semibold tracking-tight">{{ 'projectsDetails.deliveryDate' | translate }}</span>
                </div>
                <span class="text-xs font-mono font-bold text-text-primary bg-surface-elevated px-2 py-0.5 rounded-md border border-border">
                  {{ deliveryDate }}
                </span>
              </div>
              }

              @if (totalUnits) {
              <div class="flex items-center justify-between pb-3.5 border-b border-border-subtle">
                <div class="flex items-center gap-2.5 text-text-secondary">
                  <div class="w-6 h-6 rounded-lg bg-surface-elevated border border-border flex items-center justify-center text-text-muted">
                    <i class="fa-solid fa-cubes text-[10px]"></i>
                  </div>
                  <span class="text-xs font-semibold tracking-tight">{{ 'projectsDetails.totalUnits' | translate }}</span>
                </div>
                <span class="text-xs font-mono font-bold text-text-primary">
                  {{ totalUnits }}
                </span>
              </div>
              }

              @if (basePrice) {
              <div class="flex items-center justify-between pb-3.5 border-b border-border-subtle">
                <div class="flex items-center gap-2.5 text-text-secondary">
                  <div class="w-6 h-6 rounded-lg bg-primary-soft border border-primary/20 flex items-center justify-center text-primary">
                    <i class="fa-solid fa-coins text-[10px]"></i>
                  </div>
                  <span class="text-xs font-semibold tracking-tight">{{ 'projectsDetails.startingPrice' | translate }}</span>
                </div>
                <span class="text-xs font-mono font-black text-primary">
                  {{ basePrice }} {{ currency }}
                </span>
              </div>
              }

              @if (availableUnits) {
              <div class="flex items-center justify-between pt-0.5">
                <div class="flex items-center gap-2.5 text-text-secondary">
                  <div class="w-6 h-6 rounded-lg bg-success-soft border border-success-border flex items-center justify-center text-success">
                    <i class="fa-solid fa-fire text-[10px]"></i>
                  </div>
                  <span class="text-xs font-semibold tracking-tight">{{ 'projectsDetails.available' | translate }}</span>
                </div>
                <div class="px-2.5 py-1 bg-success-soft border border-success-border rounded-xl flex items-center gap-1.5">
                  <div class="w-1.5 h-1.5 rounded-full bg-success"></div>
                  <span class="text-[11px] font-mono font-black text-success uppercase tracking-wide">
                    {{ availableUnits }}
                  </span>
                </div>
              </div>
              }
            </div>
          </div>

          <!-- Owner Performance -->
          <div class="surface-card rounded-3xl p-5 md:p-6 antialiased">
            <div class="flex items-center gap-2 mb-5 pb-2 border-b border-border-subtle">
              <div class="w-1.5 h-3.5 bg-primary rounded-sm shadow-sm"></div>
              <h3 class="text-xs font-black text-text-primary uppercase tracking-wider font-mono">
                {{ 'projectsDetails.developerPerformance' | translate }}
              </h3>
            </div>

            <div class="space-y-4">
              <div class="flex items-center justify-between pb-3.5 border-b border-border-subtle">
                <div class="flex items-center gap-2.5 text-text-secondary">
                  <div class="w-6 h-6 rounded-lg bg-warning-soft border border-warning-border flex items-center justify-center text-warning">
                    <i class="fa-solid fa-star text-[10px]"></i>
                  </div>
                  <span class="text-xs font-semibold tracking-tight">{{ 'projectsDetails.averageRating' | translate }}</span>
                </div>
                <div class="flex items-center gap-1">
                  <span class="text-xs font-mono font-black text-text-primary">{{ averageRating | number:'1.1-1' }}</span>
                  <i class="fa-solid fa-star text-warning text-[9px]"></i>
                </div>
              </div>

              <div class="flex items-center justify-between pb-3.5 border-b border-border-subtle">
                <div class="flex items-center gap-2.5 text-text-secondary">
                  <div class="w-6 h-6 rounded-lg bg-info-soft border border-info-border flex items-center justify-center text-info">
                    <i class="fa-solid fa-message text-[10px]"></i>
                  </div>
                  <span class="text-xs font-semibold tracking-tight">{{ 'projectsDetails.totalReviews' | translate }}</span>
                </div>
                <span class="text-xs font-mono font-bold text-text-primary">{{ totalReviews }}</span>
              </div>

              @if (successRate > 0) {
              <div class="flex items-center justify-between pb-3.5 border-b border-border-subtle">
                <div class="flex items-center gap-2.5 text-text-secondary">
                  <div class="w-6 h-6 rounded-lg bg-success-soft border border-success-border flex items-center justify-center text-success">
                    <i class="fa-solid fa-chart-line text-[10px]"></i>
                  </div>
                  <span class="text-xs font-semibold tracking-tight">Success Rate</span>
                </div>
                <span class="text-xs font-mono font-bold text-success">{{ successRate }}%</span>
              </div>
              }

              @if (responseTimeLabel) {
              <div class="flex items-center justify-between">
                <div class="flex items-center gap-2.5 text-text-secondary">
                  <div class="w-6 h-6 rounded-lg bg-primary-soft border border-primary/20 flex items-center justify-center text-primary">
                    <i class="fa-solid fa-clock text-[10px]"></i>
                  </div>
                  <span class="text-xs font-semibold tracking-tight">Response Time</span>
                </div>
                <span class="text-xs font-mono font-bold text-text-primary">{{ responseTimeLabel }}</span>
              </div>
              }
            </div>
          </div>

          <app-contact-form [projectId]="projectId" [unitTypes]="unitTypeNames">
          </app-contact-form>

          <app-action-buttons (requestCall)="onRequestCall()" (bookVisit)="onBookVisit()" (getBrochure)="onGetBrochure()">
          </app-action-buttons>
        </div>
      </div>

    </div>
    }
  </div>

  <!-- Book Visit Modal -->
  @if (isVisitModalOpen) {
  <div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-fadeIn">
    <div class="surface-card border border-border-strong rounded-3xl p-6 sm:p-8 max-w-lg w-full shadow-2xl relative space-y-6">
      <div class="flex items-center justify-between pb-4 border-b border-border-subtle">
        <div class="flex items-center gap-3">
          <div class="w-10 h-10 rounded-2xl bg-primary-soft border border-primary/20 flex items-center justify-center text-primary">
            <i class="fa-solid fa-calendar-days text-sm"></i>
          </div>
          <div>
            <h3 class="text-base font-black text-text-primary tracking-tight">{{ 'projectsDetails.bookVisit' | translate }}</h3>
            <p class="text-xs text-text-muted">{{ projectName }}</p>
          </div>
        </div>
        <button (click)="closeVisitModal()" class="w-8 h-8 rounded-full bg-surface-elevated hover:bg-surface-hover border border-border flex items-center justify-center text-text-secondary hover:text-text-primary transition-colors">
          <i class="fa-solid fa-xmark text-xs"></i>
        </button>
      </div>

      @if (visitSuccessMessage) {
        <div class="p-4 bg-success-soft border border-success-border text-success text-xs font-semibold rounded-2xl flex items-center gap-2.5">
          <i class="fa-solid fa-circle-check text-sm shrink-0"></i>
          <span>{{ visitSuccessMessage }}</span>
        </div>
      }

      @if (visitErrorMessage) {
        <div class="p-4 bg-danger-soft border border-danger-border text-danger text-xs font-semibold rounded-2xl flex items-center gap-2.5">
          <i class="fa-solid fa-circle-exclamation text-sm shrink-0"></i>
          <span>{{ visitErrorMessage }}</span>
        </div>
      }

      <form class="space-y-4" (ngSubmit)="submitBookVisit()">
        <div>
          <label class="block text-xs font-semibold text-text-secondary mb-1.5">{{ 'projectsDetails.fullName' | translate }} *</label>
          <input type="text" [(ngModel)]="visitForm.name" name="visitName" required class="form-input w-full" placeholder="الاسم الكامل" />
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label class="block text-xs font-semibold text-text-secondary mb-1.5">{{ 'projectsDetails.phoneNumber' | translate }} *</label>
            <input type="tel" [(ngModel)]="visitForm.phone" name="visitPhone" required dir="ltr" class="form-input w-full text-left font-mono font-bold" placeholder="+20 10..." />
          </div>
          <div>
            <label class="block text-xs font-semibold text-text-secondary mb-1.5">{{ 'projectsDetails.emailAddress' | translate }}</label>
            <input type="email" [(ngModel)]="visitForm.email" name="visitEmail" class="form-input w-full" placeholder="name@example.com" />
          </div>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label class="block text-xs font-semibold text-text-secondary mb-1.5">تاريخ الزيارة *</label>
            <input type="date" [(ngModel)]="visitForm.date" name="visitDate" required class="form-input w-full font-mono text-sm" />
          </div>
          <div>
            <label class="block text-xs font-semibold text-text-secondary mb-1.5">الفترة المفضلة</label>
            <select [(ngModel)]="visitForm.timeSlot" name="visitTime" class="form-select w-full text-xs">
              <option value="10:00 AM">10:00 AM - صباحاً</option>
              <option value="12:00 PM">12:00 PM - ظهراً</option>
              <option value="02:00 PM">02:00 PM - عصراً</option>
              <option value="04:00 PM">04:00 PM - مساءً</option>
              <option value="06:00 PM">06:00 PM - مساءً</option>
            </select>
          </div>
        </div>

        <div>
          <label class="block text-xs font-semibold text-text-secondary mb-1.5">ملاحظات إضافية</label>
          <textarea [(ngModel)]="visitForm.notes" name="visitNotes" rows="2" class="form-input w-full resize-none text-xs" placeholder="أي تفاصيل ترغب بتوضيحها..."></textarea>
        </div>

        <div class="flex items-center justify-end gap-3 pt-4 border-t border-border-subtle">
          <button type="button" (click)="closeVisitModal()" class="btn-secondary text-xs px-5 py-2.5 rounded-xl">إلغاء</button>
          <button type="submit" [disabled]="isSubmittingVisit" class="btn-primary text-xs px-6 py-2.5 rounded-xl flex items-center gap-2 disabled:opacity-50">
            @if (isSubmittingVisit) {
              <i class="fa-solid fa-spinner fa-spin text-xs"></i>
              <span>جاري التأكيد...</span>
            } @else {
              <span>تأكيد موعد الزيارة</span>
              <i class="fa-solid fa-arrow-right-long text-[10px]"></i>
            }
          </button>
        </div>
      </form>
    </div>
  </div>
  }
</div>